import { useMemo } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import TextInput from 'src/components/TextInput';

import PopUp from 'src/components/design-system/PopUp';
import { getBgColor, getIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import OcrIndicator from '../split_line_item/OcrIndicator';

const InvoiceNumber = () => {
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const handleInputChange = useContextSelector(InvoiceContext, (value) => value.handleInputChange);
  const ocrResponse = useContextSelector(InvoiceContext, (value) => value.ocrResponse);
  const initialInvoice = useContextSelector(InvoiceContext, (value) => value.initialInvoice);
  const handleHoverOcrField = useContextSelector(
    InvoiceContext,
    (value) => value.handleHoverOcrField
  );
  const title = useContextSelector(InvoiceContext, (value) => value.title);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const errors = useContextSelector(InvoiceContext, (value) => value.errors);
  const informations = useContextSelector(InvoiceContext, (value) => value.informations);

  const hasErrors = useMemo(() => !!errors.invoiceNumber.length, [errors.invoiceNumber.length]);

  const isEdited = useMemo(
    () =>
      ocrResponse.invoiceNumber?.value?.toLowerCase()?.trim() !==
      invoice?.invoiceNumber?.toLowerCase()?.trim(),
    [invoice.invoiceNumber, ocrResponse.invoiceNumber?.value]
  );
  const showOcrIndicator = useMemo(() => {
    const confidence = ocrResponse?.invoiceNumber?.confidence;
    const hasMeaningfulConfidence =
      confidence != null && confidence !== '' && parseFloat(confidence) !== 0;
    return Boolean(
      initialInvoice?.ocrGenerated && hasMeaningfulConfidence && invoice?.invoiceNumber
    );
  }, [initialInvoice?.ocrGenerated, ocrResponse?.invoiceNumber?.confidence, invoice?.invoiceNumber]);
  return (
    <PopUp
      content={
        <div className="flex flex-col gap-2">
          <PopUpContentWrapper type="Information" contents={informations.invoiceNumber} />
          <PopUpContentWrapper type="Error" contents={errors.invoiceNumber} />
        </div>
      }
      show={hasErrors || !!informations.invoiceNumber}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'right', vertical: 'top' }}
    >
      <div
        className={`p-1 ${getBgColor(
          errors.invoiceNumber,
          [],
          informations.invoiceNumber
        )} text-[13px]`}
      >
        <p className="font-bold flex items-center pb-1">
          {title} #
          <span className=" flex items-center flex-grow">
            <div className="px-1">
              {getIcon(errors.invoiceNumber, [], informations.invoiceNumber)}
            </div>
            <div className="ml-auto">
              {showOcrIndicator && (
                <OcrIndicator
                  isEdited={isEdited}
                  ocrConfidence={ocrResponse.invoiceNumber?.confidence ?? ''}
                  onHover={() => handleHoverOcrField('invoiceNumber')}
                />
              )}
            </div>
          </span>
        </p>
        {isInvoiceEditDisabled ? (
          <p title={invoice?.invoiceNumber || ''}>{invoice?.invoiceNumber || ''}</p>
        ) : (
          <TextInput
            title={invoice?.invoiceNumber || ''}
            value={String(invoice?.invoiceNumber || '')}
            onChange={handleInputChange('invoiceNumber')}
            onFocus={() => handleHoverOcrField('invoiceNumber')}
            ocr-data="invoiceNumber"
          />
        )}
      </div>
    </PopUp>
  );
};

export default InvoiceNumber;
